import {createRouter, createWebHistory, createMemoryHistory} from 'vue-router';
import PersonalizationRoutes from './PersonalizationRoutes';
import PredictionsRoutes from './PredictionsRoutes';
//import MessagesRoutes from "@/router/MessagesRoutes";
import ProfileRoutes from "@/router/ProfileRoutes";
import SettingsRoutes from "@/router/SettingsRoutes";
import TestRoutes from "@/router/TestRoutes";

const routes = [
    {
        path: "/",
        name: 'welcome',
        component: () => import('@/views/WelcomeView.vue')
    },
    {
        path: '/p/:id(\\w{6})',
        name: 'shared-map',
        component: () => import('@/views/Profile/PersonalityMap/Shared.vue')
    },
    PersonalizationRoutes,
    PredictionsRoutes,
//    MessagesRoutes,
    ProfileRoutes,
    SettingsRoutes,
    TestRoutes,
    {
        path: "/map-ready",
        name: 'map-ready',
        component: () => import('@/views/Profile/PersonalityMap/BlurryMap.vue')
    },
    {
        path: "/login",
        name: 'login',
        component: () => import('@/views/Login.vue')
    },
    {
        path: "/fake-lp",
        name: 'lp',
        component: () => import('@/views/FakeLP.vue')
    },
    {
        path: "/kvkk",
        name: 'kvkk',
        component: () => import('@/views/KVKK.vue')
    },
    {
        path: "/subscription",
        name: 'subs',
        component: () => import('@/views/Subscription.vue')
    }
];

export default createRouter({
    history: createWebHistory(),
//    history: createMemoryHistory(),
//    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {
            top: 0
        }
    },
});
